function consent(text,accept,hide,info,url,age,trackingId){
	var unix=Math.round((new Date()).getTime()/1000);
	var expire=age*24*60*60;

	if(
		(localStorage['privacy']==null)||
		((localStorage['privacy']!='')&&(localStorage['privacy']<unix-expire))
	){
		document.body.insertAdjacentHTML('afterbegin','<div class="privacy">'+text+'<div class="box"><a class="info" href="'+url+'" target="_blank">'+info+'</a><a class="hide">'+hide+'</a><a class="accept">'+accept+'</a></div></div>');
	}else{
		optin(trackingId);
	}

	var acceptBtn=document.querySelector('.accept');
	if(acceptBtn){
		acceptBtn.addEventListener('click',function(){
			localStorage['privacy']=unix;
			optin(trackingId);
			var el=document.querySelector('.privacy');
			if(el)el.remove();
		});
	}

	var hideBtn=document.querySelector('.hide');
	if(hideBtn){
		hideBtn.addEventListener('click',function(){
			var el=document.querySelector('.privacy');
			if(el)el.remove();
		});
	}
}

window.dataLayer=window.dataLayer||[];
function gtag(){
	dataLayer.push(arguments);
}
function optin(trackingId){
	if(localStorage['dev']==null){
		var s=document.createElement('script');
		s.src="https://www.googletagmanager.com/gtag/js?id="+trackingId;
		s.onload=function(){
			gtag('js',new Date());
			gtag('config',trackingId);
		};
		document.head.appendChild(s);
		console.log('tracking');
	}else{
		console.log('devmode');
	}
}